// Exports the "lineheight" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/lineheight')
//   ES2015:
//     import 'tinymce/plugins/lineheight'
require('./plugin.js');